import type { QueryFunction, QueryFunctionContext } from '@tanstack/react-query';

import buildRequest, { IBuildRequestConfig, ISearchParams } from './buildRequest';
import executeRequest, { IExecuteRequestConfig } from './executeRequest';

export type IQueryKeyOptions<SearchParams = ISearchParams, Params = undefined> = (SearchParams extends undefined
  ? {}
  : { searchParams: SearchParams }) &
  (Params extends undefined ? {} : { params: Params });
export type IQueryKeyWithOptions<SearchParams = ISearchParams, Params = undefined> = [string, IQueryKeyOptions<SearchParams, Params>];
export type IQueryKey<SearchParams = undefined, Params = undefined> = SearchParams extends undefined
  ? [string]
  : IQueryKeyWithOptions<SearchParams, Params>;

export type IQueryFnFactoryConfig = Pick<IBuildRequestConfig, 'headers' | 'host' | 'accepts'> & IExecuteRequestConfig;

export default function queryFnFactory<TData = Record<string, unknown>>({
  headers,
  accepts,
  host,
  errorType,
  responseType,
}: IQueryFnFactoryConfig = {}): QueryFunction<TData, IQueryKey<ISearchParams>> {
  return async function queryFn({
    queryKey: [path, { searchParams } = {} as IQueryKeyOptions],
  }: QueryFunctionContext<IQueryKey<ISearchParams>>): Promise<TData> {
    return executeRequest(
      buildRequest({
        host,
        path,
        searchParams,
        headers,
        accepts,
      }),
      { errorType, responseType },
    );
  };
}
